import _regeneratorRuntime from '@babel/runtime/regenerator';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { joinUrlPaths, makeQuery, joinQueries, toSet, resolveLocale } from '@appiodev/xcore-utils';
export * from '@appiodev/xcore-utils';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _construct from '@babel/runtime/helpers/construct';
import _typeof from '@babel/runtime/helpers/typeof';
import { isNil, adjust } from 'ramda';
import _createClass from '@babel/runtime/helpers/createClass';

var RouteTypes;

(function (RouteTypes) {
  RouteTypes["Content"] = "content";
  RouteTypes["Alias"] = "alias";
  RouteTypes["Absolute"] = "absolute";
})(RouteTypes || (RouteTypes = {}));

var Method;

(function (Method) {
  Method["Create"] = "POST";
  Method["Edit"] = "PUT";
})(Method || (Method = {}));

var logRequest = function logRequest(s) {
  process.env.VERBOSE === "1" && console.info("\x1B[2mreq - ".concat(String(s), "\x1B[0m"));
  return s;
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var XcoreError = /*#__PURE__*/function (_Error) {
  _inherits(XcoreError, _Error);

  var _super = _createSuper(XcoreError);

  function XcoreError(url, msg) {
    var _this;

    _classCallCheck(this, XcoreError);

    _this = _super.call(this, msg);
    _this.name = undefined;
    _this.url = url;
    return _this;
  }

  return XcoreError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var AuthError = /*#__PURE__*/function (_XcoreError) {
  _inherits(AuthError, _XcoreError);

  var _super = _createSuper$1(AuthError);

  function AuthError(url, res) {
    var _this;

    _classCallCheck(this, AuthError);

    _this = _super.call(this, url, "Request failed due to authentication error: ".concat(res.statusText, " (").concat(res.status, ")"));
    _this.name = "AuthError";
    _this.response = res;
    return _this;
  }

  return AuthError;
}(XcoreError);

var handleSaveError = function handleSaveError(getError) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, res) {
      var _res$headers$get;

      var serverError;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              serverError = !((_res$headers$get = res.headers.get("content-type")) !== null && _res$headers$get !== void 0 && _res$headers$get.includes("json"));
              _context.t0 = getError;
              _context.t1 = url;
              _context.t2 = res;

              if (serverError) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return res.json();

            case 7:
              _context.t3 = _context.sent.errors;
              _context.next = 11;
              break;

            case 10:
              _context.t3 = undefined;

            case 11:
              _context.t4 = _context.t3;

              if (!serverError) {
                _context.next = 18;
                break;
              }

              _context.next = 15;
              return res.text();

            case 15:
              _context.t5 = _context.sent;
              _context.next = 19;
              break;

            case 18:
              _context.t5 = undefined;

            case 19:
              _context.t6 = _context.t5;
              throw (0, _context.t0)(_context.t1, _context.t2, _context.t4, _context.t6);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var handleAuthError = function handleAuthError(res, url) {
  if (res.status === 401 || res.status === 403) {
    throw new AuthError(url, res);
  }

  return res;
};

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var TimeoutError = /*#__PURE__*/function (_XcoreError) {
  _inherits(TimeoutError, _XcoreError);

  var _super = _createSuper$2(TimeoutError);

  function TimeoutError(url, timeout) {
    var _this;

    _classCallCheck(this, TimeoutError);

    _this = _super.call(this, url, "Request to \"".concat(url, "\" timed out (timeout: ").concat(timeout, ")"));
    _this.name = "TimeoutError";
    return _this;
  }

  return TimeoutError;
}(XcoreError);

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var LoginErrorType;

(function (LoginErrorType) {
  LoginErrorType["InvalidCredentials"] = "Invalid credentials.";
  LoginErrorType["Invalid2FA"] = "Invalid 2FA code.";
  LoginErrorType["No2FAYet"] = "Doesn't have 2FA yet, generate QRCode";
  /** User already has 2fa setup, but it was not provided in request */

  LoginErrorType["No2FAProvided"] = "2FA code is required for admin.";
})(LoginErrorType || (LoginErrorType = {}));

var LoginError = /*#__PURE__*/function (_XcoreError) {
  _inherits(LoginError, _XcoreError);

  var _super = _createSuper$3(LoginError);

  function LoginError(url, body) {
    var _this;

    _classCallCheck(this, LoginError);

    _this = _super.call(this, url, "Login error");
    _this.name = "LoginError";
    _this.type = parseErrorTypeFromErrorBody(body);
    return _this;
  }

  return LoginError;
}(XcoreError);

var parseErrorTypeFromErrorBody = function parseErrorTypeFromErrorBody(body) {
  if (!body) {
    return undefined;
  }

  var values = Object.values(body);
  var errorTypesMessages = Object.values(LoginErrorType);

  if (Array.isArray(values[0]) && errorTypesMessages.includes(values[0][0])) {
    return values[0][0];
  }

  return undefined;
};

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var SaveContentError = /*#__PURE__*/function (_XcoreError) {
  _inherits(SaveContentError, _XcoreError);

  var _super = _createSuper$4(SaveContentError);

  function SaveContentError(url, res, errors, serverError) {
    var _this;

    _classCallCheck(this, SaveContentError);

    _this = _super.call(this, url, "Unable to save content");
    _this.name = "SaveContentError";
    _this.response = res;
    _this.errors = errors !== null && errors !== void 0 ? errors : {};
    _this.serverError = serverError;
    return _this;
  }

  return SaveContentError;
}(XcoreError);

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var SaveCategoryError = /*#__PURE__*/function (_XcoreError) {
  _inherits(SaveCategoryError, _XcoreError);

  var _super = _createSuper$5(SaveCategoryError);

  function SaveCategoryError(url, res, errors, serverError) {
    var _this;

    _classCallCheck(this, SaveCategoryError);

    _this = _super.call(this, url, "Unable to save category");
    _this.name = "SaveCategoryError";
    _this.response = res;
    _this.errors = errors !== null && errors !== void 0 ? errors : {};
    _this.serverError = serverError;
    return _this;
  }

  return SaveCategoryError;
}(XcoreError);

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var SaveUserError = /*#__PURE__*/function (_XcoreError) {
  _inherits(SaveUserError, _XcoreError);

  var _super = _createSuper$6(SaveUserError);

  function SaveUserError(url, res, errors, serverError) {
    var _this;

    _classCallCheck(this, SaveUserError);

    _this = _super.call(this, url, "Unable to save user");
    _this.name = "SaveUserError";
    _this.response = res;
    _this.errors = errors !== null && errors !== void 0 ? errors : {};
    _this.serverError = serverError;
    return _this;
  }

  return SaveUserError;
}(XcoreError);

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var SaveGroupError = /*#__PURE__*/function (_XcoreError) {
  _inherits(SaveGroupError, _XcoreError);

  var _super = _createSuper$7(SaveGroupError);

  function SaveGroupError(url, res, errors, serverError) {
    var _this;

    _classCallCheck(this, SaveGroupError);

    _this = _super.call(this, url, "Unable to save group");
    _this.name = "SaveGroupError";
    _this.response = res;
    _this.errors = errors !== null && errors !== void 0 ? errors : {};
    _this.serverError = serverError;
    return _this;
  }

  return SaveGroupError;
}(XcoreError);

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var ChangePasswordError = /*#__PURE__*/function (_XcoreError) {
  _inherits(ChangePasswordError, _XcoreError);

  var _super = _createSuper$8(ChangePasswordError);

  function ChangePasswordError(url, res, errors, serverError) {
    var _this;

    _classCallCheck(this, ChangePasswordError);

    _this = _super.call(this, url, "Unable to change password");
    _this.name = "ChangePasswordError";
    _this.response = res;
    _this.errors = errors !== null && errors !== void 0 ? errors : {};
    _this.serverError = serverError;
    return _this;
  }

  return ChangePasswordError;
}(XcoreError);

var errorRecord = {
  AuthError: AuthError,
  TimeoutError: TimeoutError,
  LoginError: LoginError,
  SaveContentError: SaveContentError,
  SaveCategoryError: SaveCategoryError,
  SaveUserError: SaveUserError,
  SaveGroupError: SaveGroupError,
  ChangePasswordError: ChangePasswordError
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Structure which copies the promise interface, but also retains the requests url
 * @template T
 * @param {string} url
 * @param {Promise<T>}
 * @returns {XcoreApiRequest<T>}
 */

var xcoreApiRequest = function xcoreApiRequest(url, p) {
  return {
    url: url,
    then: function then(onFulfilled, onRejected) {
      return xcoreApiRequest(url, p.then(onFulfilled && function (v) {
        return onFulfilled(v, url);
      }, onRejected));
    },
    "catch": function _catch(onRejected) {
      return xcoreApiRequest(url, p["catch"](onRejected));
    },
    catchXcoreError: function catchXcoreError(name, onRejected) {
      var ErrorClass = typeof name === "string" ? errorRecord[name] : XcoreError;
      var handler = typeof name === "string" ? onRejected : name;
      return xcoreApiRequest(url, p["catch"](function (e) {
        if (e instanceof ErrorClass) return handler(e);
        throw e;
      }));
    },
    toPromise: function () {
      var _toPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return p;

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function toPromise() {
        return _toPromise.apply(this, arguments);
      }

      return toPromise;
    }()
  };
};
/**
 * Structure which copies the promise interface, also retains the request url and ignores any then transform
 * @template T
 * @param {string} url
 * @param {Promise<T>}
 * @returns {NoopPromise<T>}
 */

var noopPromise = function noopPromise(url, p) {
  return _objectSpread(_objectSpread({}, xcoreApiRequest(url, p)), {}, {
    then: function then(_, onRejected) {
      return noopPromise(url, p.then(undefined, onRejected));
    }
  });
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @deprecated use cms.fetch instead */

var xcoreFetch = function xcoreFetch(req, init, timeout) {
  var _init$requestHandler;

  var requestHandler = (_init$requestHandler = init.requestHandler) !== null && _init$requestHandler !== void 0 ? _init$requestHandler : defaultRequestHandler;
  return requestHandler(joinUrlPaths(init.apiUrl, req), init, timeout);
};
/** @deprecated apiFetch was renamed to xcoreFetch */

var apiFetch = xcoreFetch;
/** Standard requestHandler which uses global fetch and timeouts after a set time */

var defaultRequestHandler = function defaultRequestHandler(req, init, timeout) {
  var _init$customFetch;

  logRequest(req);
  return xcoreApiRequest(req, fetchWithTimeout((_init$customFetch = init === null || init === void 0 ? void 0 : init.customFetch) !== null && _init$customFetch !== void 0 ? _init$customFetch : fetch, req, _objectSpread$1(_objectSpread$1({}, init), {}, {
    credentials: "include",
    mode: "cors",
    headers: _objectSpread$1(_objectSpread$1({
      "content-type": "application/json"
    }, init === null || init === void 0 ? void 0 : init.headers), init !== null && init !== void 0 && init.authToken ? {
      Authorization: "Bearer ".concat(init.authToken)
    } : undefined)
  }), timeout)).then(handleAuthError);
};

var fetchWithTimeout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetchFunc, req, info, timeout) {
    var _ref2, _process$env$XCORE_RE, _info$signal;

    var timeoutDuration, abort, timeoutId, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeoutDuration = +((_ref2 = (_process$env$XCORE_RE = process.env.XCORE_REQUEST_TIMEOUT) !== null && _process$env$XCORE_RE !== void 0 ? _process$env$XCORE_RE : timeout) !== null && _ref2 !== void 0 ? _ref2 : 10000);
            abort = new AbortController(); // abort the request after the timeout duration

            timeoutId = setTimeout(function () {
              return abort.abort();
            }, timeoutDuration); // if the fetch call has its own abort signal, pass it down to the inner one

            info === null || info === void 0 ? void 0 : (_info$signal = info.signal) === null || _info$signal === void 0 ? void 0 : _info$signal.addEventListener("abort", function () {
              return abort.abort();
            });
            _context.prev = 4;
            _context.next = 7;
            return fetchFunc(req, _objectSpread$1(_objectSpread$1({}, info), {}, {
              signal: abort.signal
            }));

          case 7:
            res = _context.sent;
            // clear the timeout to prevent memory leaks
            clearTimeout(timeoutId);
            return _context.abrupt("return", res);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);

            if (!(_context.t0 instanceof Error && _context.t0.name === "AbortError")) {
              _context.next = 16;
              break;
            }

            throw new TimeoutError(req, timeoutDuration);

          case 16:
            throw _context.t0;

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 12]]);
  }));

  return function fetchWithTimeout(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/** @deprecated use cms.apiRoot instead */

var getApiRoot = function getApiRoot(ctx) {
  return xcoreFetch("/api", ctx).then(function (res) {
    return res.json();
  });
};

var isSlugDuplicate = function isSlugDuplicate(ctx, params) {
  return xcoreFetch("/api/route/slugs/duplicate?".concat(getRouteQuery(params)), ctx).then(function (r) {
    return r.json();
  });
};

var getRouteQuery = function getRouteQuery(_ref) {
  var contentType = _ref.contentType,
      contentId = _ref.contentId,
      slug = _ref.slug,
      locale = _ref.locale;
  return makeQuery("contentId", "slug", "locale", "contentType")(contentId, slug, locale, contentType);
};

var paginateQuery = function paginateQuery(page, perPage) {
  return makeQuery("page", "perPage")(page, perPage);
};
var parseRangeHeader = function parseRangeHeader(header) {
  var _2 = _slicedToArray(_toConsumableArray(header === null || header === void 0 ? void 0 : header.matchAll(/items (\d+)-(\d+)\/(\d+)/g))[0], 4),
      _ = _2[0],
      from = _2[1],
      to = _2[2],
      end = _2[3];

  return {
    from: +from,
    to: +to,
    end: +end
  };
};
var paginateRes = function paginateRes(res) {
  return res.json().then(function (x) {
    return [x, res.headers.get("content-range") ? parseRangeHeader(res.headers.get("content-range")) : null];
  });
};

var getQuery = function getQuery(_ref, _ref2) {
  var locales = _ref.locales,
      published = _ref.published;
  var fields = _ref2.fields,
      includeFiles = _ref2.includeFiles,
      includeValues = _ref2.includeValues,
      relations = _ref2.relations,
      includeRelations = _ref2.includeRelations;
  return makeQuery("fields", "includeFiles", "includeValues", "includeRelations", "locales", "published")(fields, includeFiles, includeValues, !!relations || includeRelations, locales.content, published !== null && published !== void 0 ? published : true);
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @deprecated use cms.taxonomy.list instead */

var getCategories = function getCategories(type, ctx) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function () {
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return xcoreFetch("/api/categories/".concat(type, "?").concat(getCategoriesQuery(ctx, options, fields)), ctx).then(function (res) {
      return res.json();
    }).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", res);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};

var getCategoriesQuery = function getCategoriesQuery(ctx) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      includeContents = _ref2.includeContents,
      options = _objectWithoutProperties(_ref2, ["includeContents"]);

  var fields = arguments.length > 2 ? arguments[2] : undefined;
  return joinQueries("includeContents=".concat(!!includeContents || fields.length > 0 || false), getQuery(ctx, _objectSpread$2(_objectSpread$2({}, options), {}, {
    fields: fields
  })));
};

/** @deprecated use cms.taxonomy.single instead */

var getCategory = function getCategory(id, ctx) {
  return xcoreFetch("/api/category/".concat(id), ctx).then(function (res) {
    return res.json();
  });
};

/** @deprecated use cms.taxonomy.completion instead */

var getCategoryCompletion = function getCategoryCompletion(id, term, locale, ctx) {
  return xcoreFetch("/api/category-completion/".concat(id, "?").concat(makeQuery("term", "locale")(term, locale)), ctx).then(function (res) {
    return res.json();
  });
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var saveCategory = function saveCategory(method) {
  return function (category, ctx) {
    var _category$id;

    return xcoreFetch("/api/category/".concat((_category$id = category.id) !== null && _category$id !== void 0 ? _category$id : ""), _objectSpread$3(_objectSpread$3({}, ctx), {}, {
      method: method,
      body: JSON.stringify(category)
    })).then(function (res, url) {
      return res.ok ? res.json() : handleSaveCategoryError(url, res);
    });
  };
};
/** @deprecated use cms.taxonomy.insert instead */

var insertCategory = saveCategory("POST");
var handleSaveCategoryError = handleSaveError(function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(SaveCategoryError, args);
});

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @deprecated use cms.taxonomy.reorder instead */

var reorderCategory = function reorderCategory(type, order, ctx) {
  return xcoreFetch("/api/categories/".concat(type, "/reorder"), _objectSpread$4(_objectSpread$4({}, ctx), {}, {
    method: "PUT",
    body: JSON.stringify(Array.isArray(order) ? Object.fromEntries(order.map(function (v, i) {
      return [v, i];
    })) : order)
  })).then(function (res) {
    return res.json();
  });
};

/** @deprecated use cms.groups.update instead */

var updateCategory = saveCategory("PUT");

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var relationHandlers = function relationHandlers(source) {
  return relationObject(source, rootSetter);
};

var relationObject = function relationObject(source, sourceSetter, options) {
  return new Proxy(handlerObject, {
    get: function get(_, k) {
      return k === Symbol.toPrimitive || k === Symbol.toStringTag ? objToPrimitive(source) : k === "$handler" ? getHandler(source, sourceSetter, options) : k === "$options" ? function (o) {
        return relationObject(source, sourceSetter, o);
      } : isNil(source[k]) ? source[k] : isPrimitive(source[k]) ? relationPrimitive(source[k], setter(source, sourceSetter, k)) : Array.isArray(source[k]) ? relationArray(source[k], setter(source, sourceSetter, k), options) : relationObject(source[k], setter(source, sourceSetter, k), options);
    },
    has: hasKey(source)
  });
};

var relationArray = function relationArray(source, sourceSetter, options) {
  var handler = source.map(function (x, i) {
    return isPrimitive(x) ? relationPrimitive(x, setter(source, sourceSetter, i)) : relationObject(x, setter(source, sourceSetter, i), options);
  });
  handler.$handler = getHandler(source, sourceSetter, options);

  handler.$options = function (o) {
    return relationObject(source, sourceSetter, o);
  };

  return handler;
};

var isPrimitive = function isPrimitive(v) {
  return _typeof(v) !== "object" && typeof v !== "undefined";
};

var relationPrimitive = function relationPrimitive(source, sourceSetter) {
  return new Proxy(handlerPrimitive, {
    get: function get(_, k) {
      return k === Symbol.toPrimitive || k === Symbol.toStringTag ? toPrimitive(source) : k === "$handler" ? getHandler(source, sourceSetter) : source[k];
    }
  });
};

var rootSetter = function rootSetter(root, setValue) {
  return setValue(root);
};

var setter = function setter(source, sourceSetter, key) {
  return function (r, v) {
    return sourceSetter(r, function (s) {
      return Array.isArray(s) ? adjust(key, function (x) {
        return v(x);
      }, s) : _objectSpread$5(_objectSpread$5({}, s), {}, _defineProperty({}, key, v(s[key])));
    });
  };
};

var toPrimitive = function toPrimitive(source) {
  return function (hint) {
    // console.trace("Handler is being converted to primitive! Source:", source);
    return hint === "number" ? Number(source) : String(source);
  };
};

var objToPrimitive = function objToPrimitive(source) {
  return function (hint) {
    console.trace("Handler is being converted to primitive! Source:", source);
    return hint === "number" ? 1 : "[Handler handler]";
  };
};

var getHandler = function getHandler(value, set, options) {
  return {
    value: value,
    setter: function setter(r, v) {
      return set(r, function () {
        return v;
      });
    },
    options: options
  };
};

var hasKey = function hasKey(source) {
  return function (_, k) {
    return k === "$handler" || k in source;
  };
}; // eslint-disable-next-line no-shadow


var handlerObject = new function HandlerObject() {
  _classCallCheck(this, HandlerObject);
}();
var handlerPrimitive = new function HandlerPrimitive() {
  _classCallCheck(this, HandlerPrimitive);
}();

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * @deprecated use cms.content.list instead
 *
 * Fetches content based on the provided types or IDs, request context, and optional options.
 * This function supports fetching content with specified fields only and pagination.
 *
 * @param typesOrIds - If array of numbers is provided this is considered as content ids, otherwise it is considered as content types.
 * @param ctx - The request context, containing information relevant to the request.
 * @param options - Optional. An object containing options for fetching content, such as sorting, categorization, and filtering.
 * @param options.sort - Content property or content field which the result should be sorted by. Can be a string, a queryable object, or an array of these with a sort direction ("desc" or "asc").
 * @param options.filter - Content property or content field which the result should be filtered by. Can be an array with a filterable object and a string, null, or undefined value.
 * @param options.page - Pagination page number.
 * @param options.perPage - How many results should be included in a page.
 * @param options.categories - Category filter. For input [[1,  2], [3,  4]], all contents which have category (1 or  2) and (3 or  4) will be fetched.
 * @param options.includeCategories - Include categories in the contents.
 * @param options.createdAt - Filter content by the date it was createdAt. Can be an array of single string, that way it is considered as olderThan, or an array of two strings than it will be considered as olderThan and newerThan.
 * @param options.publishedAt - Filter content by the date it was publishedAt. Can be an array of single string, that way it is considered as olderThan, or an array of two strings than it will be considered as olderThan and newerThan.
 * @param options.filterByRelations - Filter content by related content IDs.
 * @param options.fields - List of specific content fields to fetch.
 * @param options.includeFiles - Include files.
 * @param options.includeValues - Include all content values. If used, it takes precedence over specified fields.
 * @param options.includeRelations - Include relation fields. For advanced purposes, use relations fields instead.
 * @param options.relations - Content relation fields which should have content fetched.
 * @param options.reverseRelations - Content reverse relation fields which should have content fetched.
 * @param paginate - Whether the response should be paginated. Defaults to `true`.
 *
 * @returns A function that, when called with an array of field names, returns a promise resolving to an `XcoreApiRequest` of `ContentsResponse<T, TField>`.
 */
// export const getContents = <T extends Content>(
//   typesOrIds: T["type"] | T["type"][] | number[],
//   ctx: RequestContext,
//   options?: GetContentsOptions<T>,
//   paginate: boolean = true
// ) =>
//   <TField extends (keyof T["values"]) & string>(fields: Array<TField> = []): XcoreApiRequest<ContentsResponse<T, TField>> =>
//     xcoreFetch(getContentsUrl(ctx, typesOrIds, { ...options, fields }), ctx)
//       .then(res => paginate ? paginateRes(res) : res.json().then(x => [x, null]))
//       .then(([c, pagination]) => ({
//         ...c,
//         options: {
//           ...options && sanitizeOptions(options),
//           prevContent: pagination?.from !== 0,
//           nextContent: pagination?.to !== pagination?.end
//         },
//         pagination: pagination && {
//           ...pagination,
//           perPage: options?.perPage ?? 50
//         }
//       }))
//       .then(async (res: ContentsResponse<T, TField>) => ({
//         ...res,
//         contents: options?.relations
//           ? await resolveContent<PickValues<T, TField>>(res.contents, ctx, options.relations, options.reverseRelations as any)
//           : res.contents
//       }));

var getContents = function getContents(types, ctx, options) {
  return function () {
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return xcoreFetch(removeDuplicateQueryParams(getContentsUrl(ctx, types, _objectSpread$6(_objectSpread$6({}, options), {}, {
      fields: fields
    }))), ctx).then(paginateRes).then(function (_ref) {
      var _options$perPage;

      var _ref2 = _slicedToArray(_ref, 2),
          c = _ref2[0],
          pagination = _ref2[1];

      return _objectSpread$6(_objectSpread$6({}, c), {}, {
        options: _objectSpread$6(_objectSpread$6({}, options && sanitizeOptions(options)), pagination && {
          prevContent: pagination.from !== 0,
          nextContent: pagination.to !== pagination.end
        }),
        pagination: _objectSpread$6(_objectSpread$6({}, pagination), {}, {
          perPage: (_options$perPage = options === null || options === void 0 ? void 0 : options.perPage) !== null && _options$perPage !== void 0 ? _options$perPage : 50
        })
      });
    }).then( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _objectSpread$6;
                _context.t1 = _objectSpread$6({}, res);
                _context.t2 = {};

                if (!(options !== null && options !== void 0 && options.relations)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return resolveContent(res.contents, ctx, options.relations, options.reverseRelations);

              case 6:
                _context.t3 = _context.sent;
                _context.next = 10;
                break;

              case 9:
                _context.t3 = res.contents;

              case 10:
                _context.t4 = _context.t3;
                _context.t5 = {
                  contents: _context.t4
                };
                return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t5));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
  };
};
var pagination = function pagination(perPage, ctx) {
  return {
    perPage: perPage,
    page: Number(ctx.query.page)
  };
};
var limit = function limit(perPage, query) {
  var _query$page;

  return {
    page: 1,
    perPage: perPage * Number((_query$page = query.page) !== null && _query$page !== void 0 ? _query$page : 1)
  };
};
/**
 * Constructs a URL for fetching content based on the provided context and options.
 *
 * @param ctx - The request context containing information relevant to the request.
 * @param typesOrIds - If array of numbers is provided this is considered as content ids, otherwise it is considered as content types.
 * @param options - An object containing options for fetching content, such as sorting, categorization, and filtering.
 *
 * @returns A string representing the URL for fetching content, including query parameters for sorting, categorization, filtering, pagination, and context-specific options.
 */

var getContentsUrl = function getContentsUrl(ctx, typesOrIds, options) {
  return "/api/contents?".concat(joinQueries(getContentsQuery(typesOrIds, options), getBaseContentsQuery(_objectSpread$6(_objectSpread$6({}, options), {}, {
    published: ctx.published
  })), getQuery(ctx, options), paginateQuery(options.page, options.perPage)));
};

var getBaseContentsQuery = function getBaseContentsQuery(_ref4) {
  var includeCategories = _ref4.includeCategories,
      createdAt = _ref4.createdAt,
      publishedAt = _ref4.publishedAt,
      filterByRelations = _ref4.filterByRelations,
      published = _ref4.published;
  return makeQuery("includeCategories", "createdAt", "publishedAt", "relations", "published")(includeCategories, createdAt, publishedAt, filterByRelations, published !== null && published !== void 0 ? published : true);
};
/**
 * Generates a query string for fetching content based on provided options.
 *
 * @param typesOrIds - If array of numbers is provided this is considered as content ids, otherwise it is considered as content types.
 * @param options - An object containing options for sorting, categorization, and filtering the content.
 * @param options.sort - A sorting option for the content.
 * @param options.categories - Categories to filter the content by.
 * @param options.filter - A filter to apply to the content.
 *
 * @returns A string representing the query for fetching content.
 */


var getContentsQuery = function getContentsQuery(typesOrIds, _ref5) {
  var _sort$;

  var sort = _ref5.sort,
      categories = _ref5.categories,
      filter = _ref5.filter;
  return [// types and ids
  typeof typesOrIds === "string" ? "types=".concat(euc(typesOrIds)) : typesOrIds.map(function (t) {
    return typeof t === "string" ? "types=".concat(t) : "ids=".concat(euc(t));
  }).join("&"), // order
  sort && (typeof sort === "string" ? "sort[0][".concat(euc(sort), "]=desc") : "sort[0][".concat(euc(sort[0]), "]=").concat(euc((_sort$ = sort[1]) !== null && _sort$ !== void 0 ? _sort$ : "asc"))), // categories
  categories === null || categories === void 0 ? void 0 : categories.map(function (r, x) {
    return r.map(function (c, y) {
      return "categories[".concat(euc(x), "][").concat(euc(y), "]=").concat(euc(c));
    }).join("&");
  }).join("&"), // filter
  (filter === null || filter === void 0 ? void 0 : filter[1]) && "filter[".concat(euc(filter[0]), "]=").concat(euc(filter[1]))].filter(Boolean).join("&");
};

var sanitizeOptions = function sanitizeOptions(_ref6) {
  var relations = _ref6.relations,
      options = _objectWithoutProperties(_ref6, ["relations"]);

  return options;
};

var euc = encodeURIComponent;

var removeDuplicateQueryParams = function removeDuplicateQueryParams(url) {
  var _url$split = url.split("?"),
      _url$split2 = _slicedToArray(_url$split, 2),
      baseUrl = _url$split2[0],
      queryParams = _url$split2[1];

  if (!queryParams) return url;
  var uniqueParams = [];

  var _iterator = _createForOfIteratorHelper(queryParams.split("&")),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var param = _step.value;
      !uniqueParams.includes(param) && uniqueParams.push(param);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return baseUrl + "?" + uniqueParams.join("&");
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var relationRepo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ids, prev, ctx) {
    var missingIdsWithOptions, _yield$Promise$all, _yield$Promise$all2, withOptions, rest, rep;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            missingIdsWithOptions = Promise.all(Object.keys(ids.withOptions).map(function (type) {
              return Object.keys(ids.withOptions[type]).map(function (fields) {
                var _prev$withOptions$typ, _prev$withOptions$typ2;

                return fetchRelations(filterIds(ids.withOptions[type][fields], (_prev$withOptions$typ = (_prev$withOptions$typ2 = prev.withOptions[type]) === null || _prev$withOptions$typ2 === void 0 ? void 0 : _prev$withOptions$typ2[fields]) !== null && _prev$withOptions$typ !== void 0 ? _prev$withOptions$typ : {}), fields.split(";"), ctx).then(appendWithOptions(type, fields));
              });
            }).flat());
            _context.next = 3;
            return Promise.all([missingIdsWithOptions, fetchBulkRelations(filterIds(ids.rest, prev.rest), ctx)]);

          case 3:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            withOptions = _yield$Promise$all2[0];
            rest = _yield$Promise$all2[1];
            rep = withOptions.reduce(function (acc, val) {
              return val(acc);
            }, prev);
            return _context.abrupt("return", _objectSpread$7(_objectSpread$7({}, rep), {}, {
              rest: _objectSpread$7(_objectSpread$7({}, prev.rest), toIdMap(rest))
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function relationRepo(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var isFinished = function isFinished(repo, prev) {
  return Object.keys(repo.rest).length === Object.keys(prev.rest).length && Object.keys(repo.withOptions).map(function (type) {
    return type in prev.withOptions && Object.keys(repo.withOptions[type]).map(function (fields) {
      return fields in prev.withOptions[type] && Object.keys(repo.withOptions[type][fields]).length === Object.keys(prev.withOptions[type][fields]).length;
    }).every(Boolean);
  }).every(Boolean);
};
var emptyRepo = function emptyRepo() {
  return {
    withOptions: {},
    rest: []
  };
};
var getContentFromRepo = function getContentFromRepo(rep, id, type, fields) {
  return type && fields ? rep.withOptions[type][fields.join(";")][id] : rep.rest[id];
};

var fetchRelations = function fetchRelations(ids, fields, ctx) {
  return ids.length > 0 ? getContents(ids, ctx, {
    includeFiles: true,
    includeCategories: true,
    includeRelations: true,
    perPage: 10000
  })(fields).then(function (c) {
    return c.contents;
  }) : xcoreApiRequest("", Promise.resolve([]));
};

var fetchBulkRelations = function fetchBulkRelations(ids, ctx) {
  return ids.length > 0 ? getContents(toSet(ids), ctx, {
    includeValues: true,
    includeFiles: true,
    includeCategories: true,
    includeRelations: true,
    perPage: 10000
  })().then(function (c) {
    return c.contents;
  }) : Promise.resolve([]);
};

var filterIds = function filterIds(ids, prev) {
  return _toConsumableArray(ids).filter(function (id) {
    return !(id in prev);
  });
};

var appendWithOptions = function appendWithOptions(type, fields) {
  return function (contents) {
    return function (prev) {
      var _prev$withOptions$typ3;

      return _objectSpread$7(_objectSpread$7({}, prev), {}, {
        withOptions: _objectSpread$7(_objectSpread$7({}, prev.withOptions), {}, _defineProperty({}, type, _objectSpread$7(_objectSpread$7({}, prev.withOptions[type]), {}, _defineProperty({}, fields, _objectSpread$7(_objectSpread$7({}, (_prev$withOptions$typ3 = prev.withOptions[type]) === null || _prev$withOptions$typ3 === void 0 ? void 0 : _prev$withOptions$typ3[fields]), toIdMap(contents))))))
      });
    };
  };
};

var toIdMap = function toIdMap(contents) {
  return contents.reduce(function (acc, val) {
    return _objectSpread$7(_objectSpread$7({}, acc), {}, _defineProperty({}, val.id, val));
  }, {});
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var resolveRelations = function resolveRelations(rep, get) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(content) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (get) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", content);

            case 2:
              result = _objectSpread$8(_objectSpread$8({}, content), {}, {
                values: getRelations(get, content.values).reduce(function (acc, val) {
                  return Array.isArray(val.$handler.value) ? resolveArray(rep)(val.$handler, acc) : resolveObject(rep)(val.$handler, acc);
                }, content.values)
              });
              return _context.abrupt("return", result);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var collectIds = function collectIds(get, prev) {
  return function (content) {
    return getRelations(get, content.values).reduce(function (acc, handler) {
      var _handler$$handler = handler === null || handler === void 0 ? void 0 : handler.$handler,
          value = _handler$$handler.value,
          options = _handler$$handler.options;

      return Array.isArray(value) ? value.reduce(function (a, val) {
        return collectIdsFromRelation(a, options)(val);
      }, acc) : collectIdsFromRelation(acc, options)(value);
    }, prev !== null && prev !== void 0 ? prev : {
      withOptions: {},
      rest: []
    });
  };
};

var collectIdsFromRelation = function collectIdsFromRelation(ids, options) {
  return function (value) {
    return options ? collectIdsWithOptions(ids, options.join(";"))(value) : collectIdsInBulk(ids)(value);
  };
};

var collectIdsWithOptions = function collectIdsWithOptions(ids, key) {
  return function (_ref2) {
    var _ids$withOptions$type, _ids$withOptions$type2;

    var id = _ref2.id,
        type = _ref2.type;
    return _objectSpread$8(_objectSpread$8({}, ids), {}, {
      withOptions: _objectSpread$8(_objectSpread$8({}, ids.withOptions), {}, _defineProperty({}, type, _objectSpread$8(_objectSpread$8({}, ids.withOptions[type]), {}, _defineProperty({}, key, [].concat(_toConsumableArray((_ids$withOptions$type = (_ids$withOptions$type2 = ids.withOptions[type]) === null || _ids$withOptions$type2 === void 0 ? void 0 : _ids$withOptions$type2[key]) !== null && _ids$withOptions$type !== void 0 ? _ids$withOptions$type : []), [id])))))
    });
  };
};

var collectIdsInBulk = function collectIdsInBulk(ids) {
  return function (value) {
    return _objectSpread$8(_objectSpread$8({}, ids), {}, {
      rest: Array.isArray(value) ? [].concat(_toConsumableArray(ids.rest), _toConsumableArray(value.map(function (v) {
        return v.id;
      }))) : [].concat(_toConsumableArray(ids.rest), [value.id])
    });
  };
};

var addContent = function addContent(rep) {
  return function (h, r) {
    var content = getContentFromRepo(rep, r.id, r.type, h.options);
    return content ? _objectSpread$8(_objectSpread$8(_objectSpread$8({}, r), content), {}, {
      _loaded: true
    }) : undefined;
  };
};

var resolveObject = function resolveObject(rep) {
  return function (handler, root) {
    var _addContent;

    return handler.setter(root, (_addContent = addContent(rep)(handler, handler.value)) !== null && _addContent !== void 0 ? _addContent : handler.value);
  };
};

var resolveArray = function resolveArray(rep) {
  return function (handler, root) {
    return handler.setter(root, handler.value.map(function (r) {
      return addContent(rep)(handler, r);
    }).filter(function (r) {
      return r !== undefined;
    }));
  };
};

var getRelations = function getRelations(get, values) {
  return flattenRelationArray(get(relationHandlers(values)));
};

var flattenRelationArray = function flattenRelationArray(handlers) {
  var flattened = [];
  handlers.forEach(function (h) {
    return h && ("$handler" in h ? flattened.push(h) : flattened.push.apply(flattened, _toConsumableArray(flattenRelationArray(h))));
  });
  return flattened;
};

var pathFinder = function pathFinder() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return new Proxy({}, {
    get: function get(_, k) {
      return k === Symbol.toPrimitive ? function () {
        return root.slice(1);
      } : typeof k === "string" ? pathFinder("".concat(root, ".").concat(k)) : pathFinder("".concat(root, "[").concat(k, "]"));
    }
  });
};

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var reverseRelation = function reverseRelation(type, get, options) {
  return [type, get(pathFinder()).filter(function (x) {
    return x !== null && x !== undefined;
  }).flat().map(String), options];
};
var resolveReverseRelation = function resolveReverseRelation(mappedObject, repo) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(content) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _objectSpread$9(_objectSpread$9({}, content), {}, {
                fetchedReverseRelations: Object.entries(mappedObject).reduce(function (acc, _ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                      k = _ref3[0],
                      val = _ref3[1];

                  return _objectSpread$9(_objectSpread$9({}, acc), {}, _defineProperty({}, k, val.map(function (v) {
                    return typeof v !== "number" ? v : repo[v];
                  })));
                }, {})
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var resolveReverseRelationsWithOptions = function resolveReverseRelationsWithOptions(getter, content, ctx) {
  return Object.entries(getter !== null && getter !== void 0 ? getter : {}).reduce( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(acc, _ref4) {
      var _content$reverseRelat, _content$reverseRelat2;

      var _ref6, k, _ref6$, type, fields, options, ids;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref6 = _slicedToArray(_ref4, 2), k = _ref6[0], _ref6$ = _slicedToArray(_ref6[1], 3), type = _ref6$[0], fields = _ref6$[1], options = _ref6$[2];
              ids = (_content$reverseRelat = (_content$reverseRelat2 = content.reverseRelations) === null || _content$reverseRelat2 === void 0 ? void 0 : _content$reverseRelat2.filter(function (r) {
                return type === r.type && fields.includes(r.field);
              }).map(function (r) {
                return r.contentId;
              })) !== null && _content$reverseRelat !== void 0 ? _content$reverseRelat : [];
              _context2.t0 = _objectSpread$9;
              _context2.t1 = _objectSpread$9;
              _context2.t2 = {};
              _context2.next = 7;
              return acc;

            case 7:
              _context2.t3 = _context2.sent;
              _context2.t4 = (0, _context2.t1)(_context2.t2, _context2.t3);
              _context2.t5 = {};
              _context2.t6 = _defineProperty;
              _context2.t7 = {};
              _context2.t8 = k;

              if (!options) {
                _context2.next = 24;
                break;
              }

              if (!(ids.length === 0)) {
                _context2.next = 18;
                break;
              }

              _context2.t10 = [];
              _context2.next = 21;
              break;

            case 18:
              _context2.next = 20;
              return getContents(ids, ctx, _objectSpread$9({
                includeValues: true,
                includeFiles: true,
                perPage: 10000
              }, options))();

            case 20:
              _context2.t10 = _context2.sent.contents;

            case 21:
              _context2.t9 = _context2.t10;
              _context2.next = 25;
              break;

            case 24:
              _context2.t9 = ids;

            case 25:
              _context2.t11 = _context2.t9;
              _context2.t12 = (0, _context2.t6)(_context2.t7, _context2.t8, _context2.t11);
              return _context2.abrupt("return", (0, _context2.t0)(_context2.t4, _context2.t5, _context2.t12));

            case 28:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }(), Promise.resolve({}));
};
var collectReverseIds = function collectReverseIds(mappedObject) {
  return Object.values(mappedObject).flat().filter(function (x) {
    return typeof x === "number";
  });
};

/** @deprecated use cms.content.utils.resolveRelations instead */

var resolveContent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, ctx, relationMap, reverseRelationMap) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", source.length !== 0 ? (relationMap ? resolveContentRelations(emptyRepo(), relationMap, source, ctx) : Promise.resolve(source)).then(function (s) {
              return reverseRelationMap ? resolveContentReverseRelations(reverseRelationMap, s, ctx) : s;
            }) : source);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolveContent(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var resolveContentRelations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(prev, relationMap, source, ctx) {
    var ids, rep;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ids = source.reduce(function (acc, val) {
              return collectIds(relationMap, acc)(val);
            }, undefined);
            _context2.next = 3;
            return relationRepo(ids, prev, ctx);

          case 3:
            rep = _context2.sent;

            if (!isFinished(rep, prev)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", source);

          case 6:
            _context2.t0 = resolveContentRelations;
            _context2.t1 = rep;
            _context2.t2 = relationMap;
            _context2.next = 11;
            return Promise.all(source.map(function (c) {
              return resolveRelations(rep, relationMap)(c);
            }));

          case 11:
            _context2.t3 = _context2.sent;
            _context2.t4 = ctx;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, _context2.t2, _context2.t3, _context2.t4));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function resolveContentRelations(_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

var resolveContentReverseRelations = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(reverseRelationMap, source, ctx) {
    var mappedObjects, reverseIds, rep;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Promise.all(source.map(function (c) {
              return resolveReverseRelationsWithOptions(reverseRelationMap, c, ctx);
            }));

          case 2:
            mappedObjects = _context3.sent;
            // Collect rest of ids
            reverseIds = {
              withOptions: {},
              rest: mappedObjects.map(collectReverseIds).flat()
            };
            _context3.next = 6;
            return relationRepo(reverseIds, emptyRepo(), ctx);

          case 6:
            rep = _context3.sent;
            return _context3.abrupt("return", Promise.all(source.map(function (c, i) {
              return resolveReverseRelation(mappedObjects[i], rep.rest)(c);
            })));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function resolveContentReverseRelations(_x9, _x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}();

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generate2faQRCode = function generate2faQRCode(ctx, params) {
  return xcoreFetch("/api/user/qrcode", _objectSpread$a(_objectSpread$a({}, ctx), {}, {
    method: "POST",
    body: JSON.stringify(params)
  }));
};

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var saveContent = function saveContent(method) {
  return function (content, ctx, force) {
    return xcoreFetch("/api/content?".concat(getSaveContentQuery(force)), _objectSpread$b(_objectSpread$b({}, ctx), {}, {
      method: method,
      body: JSON.stringify(content)
    })).then(function (res, url) {
      return res.ok ? res.json() : handleSaveContentError(url, res);
    });
  };
};
/** @deprecated use cms.content.insert instead */

var insertContent = saveContent("POST");
var handleSaveContentError = handleSaveError(function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(SaveContentError, args);
});

var getSaveContentQuery = function getSaveContentQuery(force) {
  return makeQuery("force")(force);
};

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$c(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var deleteAllReverseRelations = function deleteAllReverseRelations(contentId, ctx) {
  return xcoreFetch("/cms/relation/reverse/".concat(contentId), _objectSpread$c(_objectSpread$c({}, ctx), {}, {
    method: "DELETE"
  })).then(function (r, url) {
    return r.ok ? undefined : handleSaveContentError(url, r);
  });
};

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$d(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var deleteReverseRelation = function deleteReverseRelation(id, ctx) {
  return xcoreFetch("/cms/relation/".concat(id), _objectSpread$d(_objectSpread$d({}, ctx), {}, {
    method: "DELETE"
  })).then(function (r, url) {
    return r.ok ? undefined : handleSaveContentError(url, r);
  });
};

var XcoreContentUtils = /*#__PURE__*/function () {
  function XcoreContentUtils(cms) {
    _classCallCheck(this, XcoreContentUtils);

    this.cms = cms;
  }

  _createClass(XcoreContentUtils, [{
    key: "fetchRichtextLinks",
    value: function fetchRichtextLinks$1(content) {
      return fetchRichtextLinks(content, this.cms);
    }
  }, {
    key: "resolveRelations",
    value: function () {
      var _resolveRelations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(content, relations, reverseRelations) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!Array.isArray(content)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", resolveContent(content, this.cms.getCtx(), relations, reverseRelations));

              case 2:
                _context.next = 4;
                return resolveContent([content], this.cms.getCtx(), relations, reverseRelations);

              case 4:
                return _context.abrupt("return", _context.sent[0]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function resolveRelations(_x, _x2, _x3) {
        return _resolveRelations.apply(this, arguments);
      }

      return resolveRelations;
    }()
  }]);

  return XcoreContentUtils;
}();

var XcoreContent = /*#__PURE__*/function () {
  function XcoreContent(cms) {
    _classCallCheck(this, XcoreContent);

    this.cms = cms;
    this.utils = new XcoreContentUtils(cms);
  }
  /**
   * Fetches specific content by ID, with support for various options and relations.
   *
   * @param id - The ID or type of the content to fetch.
   * @param relationMapOrOptions - Optional. A map of relations to fetch or options for fetching content.
   *
   * @returns An `XcoreApiRequest` that resolves to a `ContentResponse<T>` or `null` if the content is not found.
   */


  _createClass(XcoreContent, [{
    key: "single",
    value: function single(id, relationMapOrOptions) {
      return getContent(id, this.cms.getCtx(), relationMapOrOptions);
    }
    /**
     * Fetches multiple contents by specifying content types or content IDs.
     * This can also be used for fetching multiple contents at once, but it gets a little tricky and limited
     * because the options specified will be applied to all contents. If I specify field `title` than that field will be fetched for all contents that are specified.
     * It is okay to use field that is only used by single content. This approach is used in `api/robe/search`.
     *
     * @typeParam T - A type extending `Content`, representing the structure of the content to be listed.
     * @typeParam TField - A type representing the fields of `T` that should be included in the response.
     *
     * @param typesOrIds - A single content type, an array of content types, or an array of content IDs.
     * @param options - Optional. An object containing options for fetching content, such as sorting, categorization, and filtering.
     * @param options.sort - Content property or content field which the result should be sorted by. Can be a string, a queryable object, or an array of these with a sort direction ("desc" or "asc").
     * @param options.filter - Content property or content field which the result should be filtered by. Can be an array with a filterable object and a string, null, or undefined value.
     * @param options.page - Pagination page number.
     * @param options.perPage - How many results should be included in a page.
     * @param options.categories - Category filter. For input [[1,  2], [3,  4]], all contents which have category (1 or  2) and (3 or  4) will be fetched.
     * @param options.includeCategories - Include categories in the contents.
     * @param options.createdAt - Filter content by the date it was createdAt. Can be an array of single string, that way it is considered as olderThan, or an array of two strings than it will be considered as olderThan and newerThan.
     * @param options.publishedAt - Filter content by the date it was publishedAt. Can be an array of single string, that way it is considered as olderThan, or an array of two strings than it will be considered as olderThan and newerThan.
     * @param options.filterByRelations - Filter content by related content IDs.
     * @param options.fields - List of specific content fields to fetch.
     * @param options.includeFiles - Include files.
     * @param options.includeValues - Include all content values. If used, it takes precedence over specified fields.
     * @param options.includeRelations - Include relation fields. For advanced purposes, use relations fields instead.
     * @param options.relations - Content relation fields which should have content fetched.
     * @param options.reverseRelations - Content reverse relation fields which should have content fetched.
     * @param paginate - Whether the response should be paginated. Defaults to `true`.
     *
     * @returns An `XcoreApiRequest` that resolves to a `ContentsResponse<T, TField>`, containing the requested content with the specified fields.
     *
     * @example Fetching single content type.
     * ```
     * const news = useXcoreQuery(cms => cms.content.list<News>("news", {
     *   fields: ["name", "image"],
     *   sort: ["createdAt", "desc"],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     *
     * @example Fetching multiple content types.
     * ```
     * const newsAndProducts = useXcoreQuery(cms => cms.content.list<News | Product>(["news", "product"], {
     *   fields: [
     *     "name", // For both product and news
     *     "intro", // Only for product
     *     "image"
     *   ],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     *
     * @example Fetching content based on content IDs.
     * ```
     * const productIds = [2568, 5842, 4512];
     *
     * const products = useXcoreQuery(cms => cms.content.list<Product>(productIds, {
     *   fields: ["title", "intro"],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     *
     * @example Fetching different content types by IDs, just be careful to resolve the types afterwards.
     * This approach is used in `api/robe/search`.
     * ```
     * const newsIds = [4587, 2435];
     * const productIds = [2568, 5842, 4512];
     *
     * const productsAndNews = useXcoreQuery(cms => cms.content.list<Product | News>([...newsIds, ...productIds], {
     *   fields: ["title", "intro"],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     */
    // public list<
    //   T extends Content,
    //   TField extends keyof T["values"] & string = keyof T["values"] & string
    // > (
    //   typesOrIds: string | number[] | string[],
    //   options: GetContentsOptions<T> & { fields?: TField[] }
    // ): XcoreApiRequest<ContentsResponse<T, TField>> {
    //   return getContents(
    //     typesOrIds,
    //     this.cms.getCtx(),
    //     options
    //   )<TField>(options?.fields);
    // }

  }, {
    key: "list",
    value: function list(typesOrIds, options) {
      return getContents(typesOrIds, this.cms.getCtx(), options)(options === null || options === void 0 ? void 0 : options.fields);
    }
    /**
     * Fetches content slugs based on the provided content types.
     * This method is useful for retrieving the URL-friendly slugs for content items,
     * which can be used for generating links or for SEO purposes.
     *
     * @param contentTypes - Optional. An array of content types for which slugs should be fetched.
     * If not specified, slugs for all content types will be fetched.
     *
     * @returns An `XcoreApiRequest` that resolves to an array of `ContentSlug` objects.
     * Each `ContentSlug` object contains the type of content and its corresponding slug.
     * ```
     * interface ContentSlug {
     *   type: string;
     *   slug: Localized;
     * }
     * ```
     */

  }, {
    key: "slugs",
    value: function slugs(contentTypes) {
      return getContentSlugs(this.cms.getCtx(), contentTypes);
    }
    /**
     * This is similar to `content.list()`, but it does not allow pagination
     *
     * Fetches multiple contents by specifying content types or content IDs.
     * This can also be used for fetching multiple contents at once, but it gets a little tricky and limited
     * because the options specified will be applied to all contents. If I specify field `title` than that field will be fetched for all contents that are specified.
     * It is okay to use field that is only used by single content. This approach is used in `api/robe/search`.
     *
     * @typeParam T - A type extending `Content`, representing the structure of the content to be listed.
     * @typeParam TField - A type representing the fields of `T` that should be included in the response.
     *
     * @param typesOrIds - A single content type, an array of content types, or an array of content IDs.
     * @param options - Optional. An object containing options for fetching content, such as sorting, categorization, and filtering.
     * @param options.sort - Content property or content field which the result should be sorted by. Can be a string, a queryable object, or an array of these with a sort direction ("desc" or "asc").
     * @param options.filter - Content property or content field which the result should be filtered by. Can be an array with a filterable object and a string, null, or undefined value.
     * @param options.page - Pagination page number.
     * @param options.perPage - How many results should be included in a page.
     * @param options.categories - Category filter. For input [[1,  2], [3,  4]], all contents which have category (1 or  2) and (3 or  4) will be fetched.
     * @param options.includeCategories - Include categories in the contents.
     * @param options.createdAt - Filter content by the date it was createdAt. Can be an array of single string, that way it is considered as olderThan, or an array of two strings than it will be considered as olderThan and newerThan.
     * @param options.publishedAt - Filter content by the date it was publishedAt. Can be an array of single string, that way it is considered as olderThan, or an array of two strings than it will be considered as olderThan and newerThan.
     * @param options.filterByRelations - Filter content by related content IDs.
     * @param options.fields - List of specific content fields to fetch.
     * @param options.includeFiles - Include files.
     * @param options.includeValues - Include all content values. If used, it takes precedence over specified fields.
     * @param options.includeRelations - Include relation fields. For advanced purposes, use relations fields instead.
     * @param options.relations - Content relation fields which should have content fetched.
     * @param options.reverseRelations - Content reverse relation fields which should have content fetched.
     * @param paginate - Whether the response should be paginated. Defaults to `true`.
     *
     * @returns An `XcoreApiRequest` that resolves to a `ContentsResponse<T, TField>`, containing the requested content with the specified fields.
     *
     * @example Fetching single content type.
     * ```
     * const news = useXcoreQuery(cms => cms.content.list<News>("news", {
     *   fields: ["name", "image"],
     *   sort: ["createdAt", "desc"],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     *
     * @example Fetching multiple content types.
     * ```
     * const newsAndProducts = useXcoreQuery(cms => cms.content.list<News | Product>(["news", "product"], {
     *   fields: [
     *     "name", // For both product and news
     *     "intro", // Only for product
     *     "image"
     *   ],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     *
     * @example Fetching content based on content IDs.
     * ```
     * const productIds = [2568, 5842, 4512];
     *
     * const products = useXcoreQuery(cms => cms.content.list<Product>(productIds, {
     *   fields: ["title", "intro"],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     *
     * @example Fetching different content types by IDs, just be careful to resolve the types afterwards.
     * This approach is used in `api/robe/search`.
     * ```
     * const newsIds = [4587, 2435];
     * const productIds = [2568, 5842, 4512];
     *
     * const productsAndNews = useXcoreQuery(cms => cms.content.list<Product | News>([...newsIds, ...productIds], {
     *   fields: ["title", "intro"],
     *   perPage: 10,
     *   // ...other options
     * }));
     * ```
     */
    // public all<
    //   T extends Content,
    //   TField extends keyof T["values"] & string = keyof T["values"] & string
    // > (
    //   typesOrIds: string | number[] | string[],
    //   options?: Omit<Omit<GetContentsOptions<T>, "page">, "perPage"> & {
    //     fields?: TField[];
    //   }
    // ): XcoreApiRequest<ContentsResponse<T, TField>> {
    //   return getContents(
    //     typesOrIds,
    //     this.cms.getCtx(),
    //     options,
    //     false
    //   )<TField>(options?.fields);
    // }

    /**
     * Fetches content suggestions based on the provided search term and optional content types.
     * Used mostly in `ContentSelect`. Similar to `content.search()` but returns more information about content.
     *
     * @param term - The search term to query the content completion API.
     * @param types - An array of content types to limit the completion suggestions to.
     *
     * @returns An `XcoreApiRequest` that resolves to an array of `Content` objects.
     * Each `Content` object represents a suggestion for the completion of the search term.
     */

  }, {
    key: "completion",
    value: function completion(term, types) {
      return getContentCompletion(term, this.cms.getCtx(), types);
    }
    /**
     *
     * Fetches search results based on the provided search term, content types, and request context.
     * This function is designed to query the content search API and return a promise resolving to a partial record of content IDs grouped by their types.
     *
     * @typeParam TKey - A type extending `string`, representing the keys of the result object, which are the content types.
     *
     * @param term - The search term to query the content search API.
     * @param types - An array of content types to limit the search results to.
     *
     * @returns An `XcoreApiRequest` that resolves to a `Partial<Record<TKey, number[]>>`, where each key is a content type and the value is an array of content IDs matching the search term and content type.
     *
     */

  }, {
    key: "search",
    value: function search(term, types) {
      return getSearchResult(term, types, this.cms.getCtx());
    }
  }, {
    key: "update",
    value: function update(content, force) {
      return updateContent(content, this.cms.getCtx(), force);
    }
  }, {
    key: "insert",
    value: function insert(content) {
      return insertContent(content, this.cms.getCtx());
    }
  }, {
    key: "delete",
    value: function _delete(content) {
      return deleteContent(content, this.cms.getCtx());
    }
  }, {
    key: "deleteReverseRelation",
    value: function deleteReverseRelation$1(content) {
      return deleteReverseRelation(content, this.cms.getCtx());
    }
  }, {
    key: "deleteAllReverseRelations",
    value: function deleteAllReverseRelations$1(content) {
      return deleteAllReverseRelations(content, this.cms.getCtx());
    }
  }, {
    key: "empty",
    value: function empty() {
      return {
        locales: [],
        categoryTypes: [],
        content: {
          id: 0,
          type: "",
          title: "",
          publishedAt: "1970-01-01T00:00:00.000Z",
          createdAt: "1970-01-01T00:00:00.000Z",
          updatedAt: "1970-01-01T00:00:00.000Z",
          values: {},
          slugAliases: {},
          contentOf: []
        }
      };
    }
  }]);

  return XcoreContent;
}();

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$e(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SUPPORTED_IMAGE_FORMATS = ["webp", "jpeg", "png"];
var XcoreFiles = /*#__PURE__*/function () {
  function XcoreFiles(cms) {
    _classCallCheck(this, XcoreFiles);

    this.cms = cms;
  }

  _createClass(XcoreFiles, [{
    key: "upload",
    value: function upload(files) {
      return uploadFiles(files, this.cms.getCtx());
    }
    /**
     * Creates URL that file is available on. Videos use legacy BE file EP and images (including SVGs) use CDN.
     *
     * 1. Layer => Image is available in cache.
     * 2. Layer => Image is available in S3.
     * 3. Layer => Image is not available and needs to be generated by lambda. It is saved to S3 afterwards.
     *
     * Every change in any of the specified lambda params generates new image
     * so it is important to avoid excessive use of different params while dealing with the same image to save resources.
     *
     * `width` and `height` params should be used in most cases, omit them only if absolutely necessary.
     * If size parameters are not provided `/get` endpoint URL will be returned instead.
     *
     *
     * @param options.withoutEnlargement Optional, defaults to `false`.
     * If set to `true` max size of original image will be returned.
     * It is recommended to use this in case of images with size around 2K.
     * If set to `false` upscaled image will be returned.
     * This may throw `500` if original image size is too small for desired enlargement.
     *
     * @param options.format Optional, defaults ot `"webp"`.
     * `jpeg` will be converted to image with white background if original image was transparent.
     */

  }, {
    key: "getFileUrl",
    value: function getFileUrl(file, options) {
      var _options$enlargement, _options$enlargement2, _options$fit;

      if (!file) {
        return undefined;
      }

      if (file !== null && file !== void 0 && file.mime.includes("video") && file !== null && file !== void 0 && file.ext) {
        if ("path" in file) {
          return joinUrlPaths(this.cms.filesUrl, "api", "files", "".concat(file.path).concat(file.ext.startsWith(".") ? file.ext : ".".concat(file.ext)));
        }

        return joinUrlPaths(this.cms.filesUrl, "api", file.url);
      }

      if (!(file !== null && file !== void 0 && file.hosted_file_url)) {
        return undefined;
      } // If URL returned is for `/get` EP parameters cannot be present


      if (file.hosted_file_url.includes("/get")) {
        return file.hosted_file_url;
      } // If size is not provided get original image stored on S3


      if (!(options !== null && options !== void 0 && options.width) && !(options !== null && options !== void 0 && options.height)) {
        var originalS3Image = transformImgHostedUrlToGetEndpointUrl(file.hosted_file_url);
        return originalS3Image;
      }

      var params = new URLSearchParams(_objectSpread$e({
        width: typeof (options === null || options === void 0 ? void 0 : options.width) === "number" ? ((options === null || options === void 0 ? void 0 : options.width) * ((_options$enlargement = options === null || options === void 0 ? void 0 : options.enlargement) !== null && _options$enlargement !== void 0 ? _options$enlargement : 1)).toString() : "auto",
        height: typeof (options === null || options === void 0 ? void 0 : options.height) === "number" ? ((options === null || options === void 0 ? void 0 : options.height) * ((_options$enlargement2 = options === null || options === void 0 ? void 0 : options.enlargement) !== null && _options$enlargement2 !== void 0 ? _options$enlargement2 : 1)).toString() : "auto",
        fit: (_options$fit = options === null || options === void 0 ? void 0 : options.fit) !== null && _options$fit !== void 0 ? _options$fit : "cover",
        withoutEnlargement: options !== null && options !== void 0 && options.withoutEnlargement ? options === null || options === void 0 ? void 0 : options.withoutEnlargement.toString() : "false"
      }, (options === null || options === void 0 ? void 0 : options.format) && SUPPORTED_IMAGE_FORMATS.includes(options.format) && {
        format: options.format
      }));
      return "".concat(file.hosted_file_url, "?").concat(params.toString());
    }
  }, {
    key: "fileSizeToString",
    value: function fileSizeToString(size) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$base = _ref.base,
          base = _ref$base === void 0 ? 1024 : _ref$base,
          _ref$prec = _ref.prec,
          prec = _ref$prec === void 0 ? 2 : _ref$prec;

      var units = base === 1000 ? decimalUnits : binaryUnits;
      var i = 0;

      while (size > base) {
        if (i > 3) break;
        size = size / base;
        i++;
      }

      return "".concat(size.toFixed(prec), " ").concat(units[i]);
    }
  }]);

  return XcoreFiles;
}();
var decimalUnits = ["B", "kB", "MB", "GB", "TB"];
var binaryUnits = ["B", "KiB", "MiB", "GiB", "TiB"];

var transformImgHostedUrlToGetEndpointUrl = function transformImgHostedUrlToGetEndpointUrl(url) {
  try {
    var urlObj = new URL(url);
    urlObj.pathname = urlObj.pathname.replace("/resize/", "/get/"); // Remove all query params

    urlObj.search = "";
    return urlObj.toString();
  } catch (error) {
    return undefined;
  }
};

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var saveGroup = function saveGroup(method) {
  return function (group, permissions, ctx) {
    return xcoreFetch("/api/groups/".concat(method === "PUT" ? group.id : ""), _objectSpread$f(_objectSpread$f({}, ctx), {}, {
      method: method,
      body: JSON.stringify({
        group: group,
        permissions: permissions
      })
    })).then(function (res, url) {
      return res.ok ? res.json() : handleSaveGroupError(url, res);
    });
  };
};
/** @deprecated use cms.groups.insert instead */

var insertGroup = saveGroup("POST");
var handleSaveGroupError = handleSaveError(function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(SaveGroupError, args);
});

/** @deprecated use cms.groups.update instead */

var updateGroup = saveGroup("PUT");

var XcoreGroups = /*#__PURE__*/function () {
  function XcoreGroups(cms) {
    _classCallCheck(this, XcoreGroups);

    this.cms = cms;
  }

  _createClass(XcoreGroups, [{
    key: "list",
    value: function list() {
      return getGroups(this.cms.getCtx());
    }
  }, {
    key: "single",
    value: function single(name) {
      return getGroup(name, this.cms.getCtx());
    }
  }, {
    key: "insert",
    value: function insert(group, permissions) {
      return insertGroup(group, permissions, this.cms.getCtx());
    }
  }, {
    key: "update",
    value: function update(group, permissions) {
      return updateGroup(group, permissions, this.cms.getCtx());
    }
  }]);

  return XcoreGroups;
}();

var listRoutes = function listRoutes(cms) {
  return cms.fetch("/api/route", cms.getCtx()).then(function (r) {
    return r.json();
  });
};

var getRoute = function getRoute(id, ctx) {
  return xcoreFetch("/api/route/".concat(id), ctx).then(function (r) {
    return r.json();
  });
};

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$g(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var upsertRoute = function upsertRoute(route, method, cms) {
  return cms.fetch("/api/route/", _objectSpread$g(_objectSpread$g({}, cms.getCtx()), {}, {
    method: method,
    body: JSON.stringify(route)
  })).then(function (r) {
    return r.json();
  });
};

var XcoreRouting = /*#__PURE__*/function () {
  function XcoreRouting(cms) {
    _classCallCheck(this, XcoreRouting);

    this.cms = cms;
  }
  /** @deprecated */


  _createClass(XcoreRouting, [{
    key: "pageContent",
    value: function pageContent(pageId) {
      return getPageContent(pageId, this.cms.getCtx());
    }
  }, {
    key: "match",
    value: function match(url) {
      if (!url.startsWith("/")) {
        return matchRoute(new URL(url).pathname, this.cms.getCtx());
      }

      return matchRoute(url, this.cms.getCtx());
    }
  }, {
    key: "isSlugDuplicate",
    value: function isSlugDuplicate$1(params) {
      return isSlugDuplicate(this.cms.getCtx(), params);
    }
  }, {
    key: "getRouteSlugList",
    value: function getRouteSlugList$1(pageId) {
      return getRouteSlugList(pageId, this.cms.getCtx());
    }
  }, {
    key: "listRoutes",
    value: function listRoutes$1() {
      return listRoutes(this.cms);
    }
  }, {
    key: "getRoute",
    value: function getRoute$1(routeId) {
      return getRoute(routeId, this.cms.getCtx());
    }
  }, {
    key: "upsertRoute",
    value: function upsertRoute$1(route) {
      var method = route.method,
          rest = _objectWithoutProperties(route, ["method"]);

      return upsertRoute(rest, method, this.cms);
    }
  }]);

  return XcoreRouting;
}();

var XcoreTaxonomy = /*#__PURE__*/function () {
  function XcoreTaxonomy(cms) {
    _classCallCheck(this, XcoreTaxonomy);

    this.cms = cms;
  }

  _createClass(XcoreTaxonomy, [{
    key: "list",
    value: function list(type, options) {
      var _options$contentField;

      return getCategories(type, this.cms.getCtx(), options)((_options$contentField = options === null || options === void 0 ? void 0 : options.contentFields) !== null && _options$contentField !== void 0 ? _options$contentField : options === null || options === void 0 ? void 0 : options.fields);
    }
  }, {
    key: "single",
    value: function single(id) {
      return getCategory(id, this.cms.getCtx());
    }
  }, {
    key: "completion",
    value: function completion(id, term, locale) {
      return getCategoryCompletion(id, term, locale, this.cms.getCtx());
    }
  }, {
    key: "insert",
    value: function insert(category) {
      return insertCategory(category, this.cms.getCtx());
    }
  }, {
    key: "reorder",
    value: function reorder(type, order) {
      return reorderCategory(type, order, this.cms.getCtx());
    }
  }, {
    key: "update",
    value: function update(category) {
      return updateCategory(category, this.cms.getCtx());
    }
    /** @deprecated use list instead */

  }, {
    key: "getCategories",
    value: function getCategories(type, options) {
      return this.list(type, options);
    }
    /** @deprecated use single instead */

  }, {
    key: "getCategory",
    value: function getCategory(id) {
      return this.single(id);
    }
  }]);

  return XcoreTaxonomy;
}();

/** @deprecated use cms.users.single instead */

var getUser = function getUser(idOrUsername, ctx) {
  return xcoreFetch("/api/user/" + idOrUsername, ctx).then(function (res) {
    return res.json();
  });
};

var XcoreUsers = /*#__PURE__*/function () {
  function XcoreUsers(cms) {
    _classCallCheck(this, XcoreUsers);

    this.cms = cms;
  }

  _createClass(XcoreUsers, [{
    key: "single",
    value: function single(idOrUsername) {
      return getUser(idOrUsername, this.cms);
    }
  }, {
    key: "list",
    value: function list() {
      return getUsers(this.cms.getCtx());
    }
  }, {
    key: "insert",
    value: function insert(user) {
      return insertUser(user, this.cms.getCtx());
    }
  }, {
    key: "update",
    value: function update(user) {
      return updateUser(user, this.cms.getCtx());
    }
  }, {
    key: "changePassword",
    value: function changePassword$1(oldPassword, newPassword) {
      return changePassword(oldPassword, newPassword, this.cms.getCtx());
    }
  }]);

  return XcoreUsers;
}();

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var createCMS = function createCMS(ctx) {
  return new XcoreCMS(ctx);
};
var XcoreCMS = /*#__PURE__*/function () {
  function XcoreCMS(ctx) {
    _classCallCheck(this, XcoreCMS);

    this._ctx = ctx;
    this.content = new XcoreContent(this);
    this.taxonomy = new XcoreTaxonomy(this);
    this.routing = new XcoreRouting(this);
    this.files = new XcoreFiles(this);
    this.users = new XcoreUsers(this);
    this.groups = new XcoreGroups(this);
  }

  _createClass(XcoreCMS, [{
    key: "getCtx",
    value: function getCtx() {
      return this._ctx;
    }
  }, {
    key: "getSerializableCtx",
    value: function getSerializableCtx() {
      var _this$_ctx = this._ctx,
          requestHandler = _this$_ctx.requestHandler,
          customFetch = _this$_ctx.customFetch,
          authToken = _this$_ctx.authToken,
          ctx = _objectWithoutProperties(_this$_ctx, ["requestHandler", "customFetch", "authToken"]);

      return ctx;
    }
  }, {
    key: "withCtx",
    value: function withCtx(ctx) {
      return new XcoreCMS(_objectSpread$h(_objectSpread$h({}, this._ctx), ctx));
    }
  }, {
    key: "login",
    value: function login(params) {
      return loginRequest(this._ctx, params);
    }
  }, {
    key: "logout",
    value: function logout() {
      return logoutRequest(this._ctx);
    }
  }, {
    key: "generate2faQRCode",
    value: function generate2faQRCode$1(params) {
      return generate2faQRCode(this._ctx, params);
    }
  }, {
    key: "fetch",
    value: function fetch(req, options, timeout) {
      return xcoreFetch(req, _objectSpread$h(_objectSpread$h({}, this._ctx), options), timeout);
    }
  }, {
    key: "apiRoot",
    value: function apiRoot() {
      return getApiRoot(this._ctx);
    }
  }, {
    key: "contentTypes",
    value: function contentTypes() {
      var minimal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return getContentTypes(this._ctx, minimal);
    }
  }, {
    key: "resolveLocale",
    value: function resolveLocale$1(localized, content) {
      return resolveLocale(this.locales.content, content)(localized);
    }
  }, {
    key: "locales",
    get: function get() {
      return this._ctx.locales;
    }
  }, {
    key: "apiUrl",
    get: function get() {
      return this._ctx.apiUrl;
    }
  }, {
    key: "filesUrl",
    get: function get() {
      return this._ctx.filesUrl;
    }
  }, {
    key: "published",
    get: function get() {
      return this._ctx.published;
    }
  }, {
    key: "authToken",
    get: function get() {
      return this._ctx.authToken;
    }
    /** @deprecated use requestHandler instead */

  }, {
    key: "customFetch",
    get: function get() {
      return this._ctx.customFetch;
    }
  }, {
    key: "requestHandler",
    get: function get() {
      return this._ctx.requestHandler;
    }
  }]);

  return XcoreCMS;
}();

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$i(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var fetchRichtextLinks = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(content, ctx) {
    var contents;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = Object;
            _context.next = 3;
            return new XcoreCMS(ctx).content.list(collectIds$1(ctx.locales.content)(content.values));

          case 3:
            _context.t1 = _context.sent.contents.map(function (c) {
              return [c.id, c];
            });
            contents = _context.t0.fromEntries.call(_context.t0, _context.t1);
            return _context.abrupt("return", _objectSpread$i(_objectSpread$i({}, content), {}, {
              values: assignValue(contents, ctx.locales.content)(content.values)
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRichtextLinks(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/** @deprecated use fetchRichtextLinks instead */

var processContent = fetchRichtextLinks;
var collectIds$1 = function collectIds(locales) {
  return function (values) {
    return Object.values(values).map(function (v) {
      if (isRichtextValue(v)) {
        return v.links;
      } else if (Array.isArray(v)) {
        return v.map(collectIds(locales)).flat();
      } else if (_typeof(v) === "object" && isLocalizedRichtextValue(v)) {
        return Object.entries(v).filter(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 1),
              l = _ref3[0];

          return locales.includes(l);
        }).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              _ = _ref5[0],
              r = _ref5[1];

          return r.links;
        }).flat();
      }

      return [];
    }).flat();
  };
};

var isRichtextValue = function isRichtextValue(v) {
  return v && _typeof(v) === "object" && "links" in v && "value" in v && Array.isArray(v.links) && Array.isArray(v.value) && Object.keys(v).length === 2;
};

var isLocalizedRichtextValue = function isLocalizedRichtextValue(v) {
  return v && _typeof(v) === "object" && Object.keys(v).length !== 0 && isRichtextValue(v[Object.keys(v)[0]]);
};

var assignValue = function assignValue(repo, locales) {
  return function (values) {
    return Object.fromEntries(Object.entries(values).map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          k = _ref7[0],
          v = _ref7[1];

      if (isRichtextValue(v)) {
        return [k, _objectSpread$i(_objectSpread$i({}, v), {}, {
          content: assignLinks(v.links, repo)
        })];
      } else if (Array.isArray(v)) {
        return [k, v.map(assignValue(repo, locales))];
      } else if (_typeof(v) === "object" && isLocalizedRichtextValue(v)) {
        return [k, assignLocalizedValue(repo, locales, v)];
      }

      return [k, v];
    }));
  };
};

var assignLinks = function assignLinks(links, repo) {
  var result = {};
  links.forEach(function (l) {
    result[l] = repo[l];
  });
  return result;
};

var assignLocalizedValue = function assignLocalizedValue(repo, locales, value) {
  return Object.fromEntries(Object.entries(value).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        l = _ref9[0],
        r = _ref9[1];

    return locales.includes(l) ? [l, _objectSpread$i(_objectSpread$i({}, r), {}, {
      content: assignLinks(r.links, repo)
    })] : [l, r];
  }));
};

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$j(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * @deprecated Use `cms.content.single` instead.
 *
 * Fetches specific content by ID, with support for various options and relations.
 *
 * @param id - The ID or type of the content to fetch.
 * @param ctx - The request context containing information relevant to the request.
 * @param relationMapOrOptions - Optional. A map of relations to fetch or options for fetching content.
 *
 * @returns An `XcoreApiRequest` that resolves to a `ContentResponse<T>` or `null` if the content is not found.
 */

var getContent = function getContent(id, ctx, relationMapOrOptions) {
  var options = normalizeOptions(relationMapOrOptions);
  return xcoreFetch("/api/content/".concat(id, "?").concat(getContentQuery(ctx, options.preview && !!ctx.authToken)), ctx).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
      var body, content;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(res.status === 404)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              _context.next = 4;
              return res.json();

            case 4:
              body = _context.sent;
              content = body.content;
              _context.next = 8;
              return resolveContent([body.content], ctx, options.relations, options.reverseRelations);

            case 8:
              content = _context.sent[0];

              if (!options.fetchRichtextLinks) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return fetchRichtextLinks(content, ctx);

            case 12:
              content = _context.sent;

            case 13:
              return _context.abrupt("return", _objectSpread$j(_objectSpread$j({}, body), {}, {
                content: content
              }));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};

var getContentQuery = function getContentQuery(ctx, preview) {
  var _ctx$published;

  return makeQuery("locales", "published")(ctx.locales.content, preview ? false : (_ctx$published = ctx.published) !== null && _ctx$published !== void 0 ? _ctx$published : true);
};

var normalizeOptions = function normalizeOptions(relationMapOrOptions) {
  return typeof relationMapOrOptions === "function" ? {
    relations: relationMapOrOptions
  } : relationMapOrOptions !== null && relationMapOrOptions !== void 0 ? relationMapOrOptions : {};
};

/** @deprecated use cms.content.completion instead */

var getContentCompletion = function getContentCompletion(term, ctx, types) {
  return xcoreFetch("/api/content/completion?".concat(makeQuery("term", "types", "locale", "published")(term, types, ctx.locales.content, ctx.published)), ctx).then(function (res) {
    return res.json();
  });
};

/** @deprecated use cms.content.update instead */

var updateContent = saveContent("PUT");

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$k(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @deprecated use cms.content.delete instead */

var deleteContent = function deleteContent(content, ctx) {
  return xcoreFetch("/api/content/".concat(typeof content === "number" ? content : content.id), _objectSpread$k(_objectSpread$k({}, ctx), {}, {
    method: "DELETE"
  })).then(function (r, url) {
    return r.ok ? undefined : handleSaveContentError(url, r);
  });
};

/** @deprecated use cms.files.upload instead */

var uploadFiles = function uploadFiles(files, ctx) {
  var formData = new FormData();

  _toConsumableArray(files).forEach(function (f) {
    return formData.append("files", f);
  });

  var url = joinUrlPaths(ctx.filesUrl, "/api/files");
  return xcoreApiRequest(url, new Promise(function (resolve, reject) {
    var ajax = new XMLHttpRequest();

    ajax.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var createdFiles = JSON.parse(this.responseText);
        resolve(createdFiles);
      }
    };

    ajax.onerror = function (e) {
      reject(e);
    };

    ajax.open("POST", url);
    ajax.withCredentials = true;
    ajax.send(formData);
  }));
};

/** @deprecated use cms.contentTypes instead */

var getContentTypes = function getContentTypes(ctx) {
  var minimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return xcoreFetch("/api/content-types?".concat(contentTypesQuery(minimal)), ctx).then(function (res) {
    return res.json();
  });
};
var contentTypesQuery = makeQuery("minimal");

/**
 * @deprecated
 * @param  page Page id of the route (exact match)
 * @param  slug Slug of the content
 * @param  ctx  Request context
 */

var getPageContent = function getPageContent(pageId, ctx) {
  return xcoreFetch("/api/content/page-content?".concat(getRouteQuery$1(pageId, ctx)), ctx).then(function (r) {
    return r.ok ? r.json() : r.status === 404 ? null : Promise.reject(new Error("Function getPageContent failed"));
  });
};

var getRouteQuery$1 = function getRouteQuery(pageId, ctx) {
  var _ctx$published;

  return makeQuery("locales", "pageId", "slug", "published")(ctx.locales.content, pageId, (_ctx$published = ctx.published) !== null && _ctx$published !== void 0 ? _ctx$published : true);
};

/**
 * @deprecated use xcore.routing.match
 * @param  url Request url without the trailing slash
 * @param  ctx Request context
 */

var matchRoute = function matchRoute(url, ctx) {
  return xcoreFetch("/api/route/match?".concat(getRouteQuery$2(url, ctx)), ctx).then(function (r) {
    return r.json();
  });
};

var getRouteQuery$2 = function getRouteQuery(url, _ref) {
  var locales = _ref.locales;
  return makeQuery("url", "locales")(url, locales.content);
};

/**
 * @deprecated use cms.routing.getRouteSlugList
 * @param  pageId PageId of the route (next.js route file path)
 * @param  ctx Request context
 */

var getRouteSlugList = function getRouteSlugList(pageId, ctx) {
  return xcoreFetch("/api/content/route-slug-list?".concat(getRouteQuery$3(pageId, ctx)), ctx).then(function (r) {
    return r.ok ? r.json() : r.status === 404 ? null : Promise.reject(new Error("Function getRouteSlugList failed"));
  });
};

var getRouteQuery$3 = function getRouteQuery(pageId, _ref) {
  var published = _ref.published;
  return makeQuery("pageId", "published")(pageId, published !== null && published !== void 0 ? published : true);
};

/**
 * @deprecated use cms.content.search instead
 *
 * Fetches search results based on the provided search term, content types, and request context.
 * This function is designed to query the content search API and return a promise resolving to a partial record of content IDs grouped by their types.
 *
 * @typeParam TKey - A type extending `string`, representing the keys of the result object, which are the content types.
 *
 * @param term - The search term to query the content search API.
 * @param types - An array of content types to limit the search results to.
 * @param ctx - The request context containing information relevant to the request, such as locales and published status.
 *
 * @returns An `XcoreApiRequest` that resolves to a `Partial<Record<TKey, number[]>>`, where each key is a content type and the value is an array of content IDs matching the search term and content type.
 *
 */

var getSearchResult = function getSearchResult(term, types, ctx) {
  return xcoreFetch("/api/content/search/".concat(term, "?").concat(getSearchQuery(types, ctx.locales.content, ctx.published)), ctx).then(function (res) {
    return res.json();
  });
};

var getSearchQuery = function getSearchQuery(types, locales, published) {
  return makeQuery("types", "locales", "published")(types, locales, published !== null && published !== void 0 ? published : true);
};

var getContentSlugs = function getContentSlugs(ctx, contentTypes) {
  return xcoreFetch("/api/content/slugs?".concat(makeQuery("contentType")(contentTypes)), ctx).then(function (res) {
    return res.json();
  });
};

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$l(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @deprecated use cms.login instead */

var loginRequest = function loginRequest(ctx, params) {
  return xcoreFetch("/api/login", _objectSpread$l(_objectSpread$l({}, ctx), {}, {
    method: "POST",
    body: JSON.stringify(params)
  })).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res, url) {
      var body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return res.json();

            case 2:
              body = _context.sent;

              if (!(res.status === 400)) {
                _context.next = 5;
                break;
              }

              throw new LoginError(url, body);

            case 5:
              return _context.abrupt("return", body);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$m(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @deprecated use cms.logout instead */

var logoutRequest = function logoutRequest(ctx) {
  return xcoreFetch("/api/user/logout", _objectSpread$m(_objectSpread$m({}, ctx), {}, {
    method: "POST"
  })).then(function () {});
};

/** @deprecated use cms.users.list instead */

var getUsers = function getUsers(ctx) {
  return xcoreFetch("/api/users", ctx).then(function (res) {
    return res.json();
  });
};

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$n(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @deprecated use cms.users.changePassword instead */

var changePassword = function changePassword(oldPassword, newPassword, ctx) {
  return xcoreFetch("/api/user/change-password", _objectSpread$n(_objectSpread$n({}, ctx), {}, {
    method: "POST",
    body: JSON.stringify({
      oldPassword: oldPassword,
      newPassword: newPassword
    })
  })).then(function (res, url) {
    return res.ok ? undefined : handleChangePasswordError(url, res);
  });
};
var handleChangePasswordError = handleSaveError(function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(ChangePasswordError, args);
});

function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$o(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var saveUser = function saveUser(method) {
  return function (user, ctx) {
    var _user$id;

    return xcoreFetch("/api/user/".concat((_user$id = user.id) !== null && _user$id !== void 0 ? _user$id : ""), _objectSpread$o(_objectSpread$o({}, ctx), {}, {
      method: method,
      body: JSON.stringify(user)
    })).then(function (res, url) {
      return res.ok ? res.json() : handleSaveUserError(url, res);
    });
  };
};
/** @deprecated use cms.users.insert instead */

var insertUser = saveUser("POST");
var handleSaveUserError = handleSaveError(function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(SaveUserError, args);
});

/** @deprecated use cms.users.update instead */

var updateUser = saveUser("PUT");

/** @deprecated use cms.groups.list instead */

var getGroups = function getGroups(ctx) {
  return xcoreFetch("/api/groups", ctx).then(function (res) {
    return res.json();
  });
};

/** @deprecated use cms.groups.single instead */

var getGroup = function getGroup(name, ctx) {
  return xcoreFetch("/api/groups/" + name, ctx).then(function (res) {
    return res.json();
  });
};

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var readXcoreConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(configPath) {
    var _yield$import, fs;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import('fs');

          case 2:
            _yield$import = _context.sent;
            fs = _yield$import.promises;
            _context.t0 = fs;

            if (!(configPath !== null && configPath !== void 0)) {
              _context.next = 9;
              break;
            }

            _context.t1 = configPath;
            _context.next = 12;
            break;

          case 9:
            _context.next = 11;
            return getXcoreConfigPath();

          case 11:
            _context.t1 = _context.sent;

          case 12:
            _context.t2 = _context.t1;
            _context.next = 15;
            return _context.t0.readFile.call(_context.t0, _context.t2).then(function (b) {
              return b.toString();
            }).then(JSON.parse)["catch"](function (e) {
              throw invalidConfigError(e);
            });

          case 15:
            return _context.abrupt("return", _context.sent);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readXcoreConfig(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getXcoreConfigPath = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$Promise$all, _yield$Promise$all2, fs, path, configPath, _iterator, _step, _loop;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = Promise;
            _context3.next = 3;
            return import('fs');

          case 3:
            _context3.t1 = _context3.sent;
            _context3.next = 6;
            return import('path');

          case 6:
            _context3.t2 = _context3.sent;
            _context3.t3 = [_context3.t1, _context3.t2];
            _context3.next = 10;
            return _context3.t0.all.call(_context3.t0, _context3.t3);

          case 10:
            _yield$Promise$all = _context3.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            fs = _yield$Promise$all2[0].promises;
            path = _yield$Promise$all2[1];
            configPath = null;
            _iterator = _createForOfIteratorHelper$1(listXcoreConfigPaths(path.resolve));
            _context3.prev = 16;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var _configPath;

              var p;
              return _regeneratorRuntime.wrap(function _loop$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      p = _step.value;

                      if (!((_configPath = configPath) !== null && _configPath !== void 0)) {
                        _context2.next = 5;
                        break;
                      }
                      _context2.next = 8;
                      break;

                    case 5:
                      _context2.next = 7;
                      return fs.access(p).then(function () {
                        return p;
                      })["catch"](function () {
                        return null;
                      });

                    case 7:
                      configPath = _context2.sent;

                    case 8:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _loop);
            });

            _iterator.s();

          case 19:
            if ((_step = _iterator.n()).done) {
              _context3.next = 23;
              break;
            }

            return _context3.delegateYield(_loop(), "t4", 21);

          case 21:
            _context3.next = 19;
            break;

          case 23:
            _context3.next = 28;
            break;

          case 25:
            _context3.prev = 25;
            _context3.t5 = _context3["catch"](16);

            _iterator.e(_context3.t5);

          case 28:
            _context3.prev = 28;

            _iterator.f();

            return _context3.finish(28);

          case 31:
            if (configPath) {
              _context3.next = 33;
              break;
            }

            throw configNotFoundError();

          case 33:
            return _context3.abrupt("return", configPath);

          case 34:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[16, 25, 28, 31]]);
  }));

  return function getXcoreConfigPath() {
    return _ref2.apply(this, arguments);
  };
}();
var readXcoreConfigSync = function readXcoreConfigSync(configPath) {
  return JSON.parse(require("fs").readFileSync(configPath !== null && configPath !== void 0 ? configPath : getXcoreConfigPathSync()).toString());
};
var getXcoreConfigPathSync = function getXcoreConfigPathSync() {
  var path = require("path");

  var fs = require("fs");

  var configPath = null;

  var _iterator2 = _createForOfIteratorHelper$1(listXcoreConfigPaths(path.resolve)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var p = _step2.value;

      if (fs.existsSync(p)) {
        configPath = p;
        break;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (!configPath) throw configNotFoundError();
  return configPath;
};
var readXcoreConfigFromEnv = function readXcoreConfigFromEnv() {
  return JSON.parse(process.env.__XCORE_CONFIG);
};

var listXcoreConfigPaths = function listXcoreConfigPaths(join) {
  return [join(process.cwd(), "xcore.config.json"), join(process.cwd(), "..", "xcore.config.json")];
};

var configNotFoundError = function configNotFoundError() {
  return new Error("Unable to access config file at ".concat(process.cwd(), ". Maybe wrong XCORE_ENV?"));
};

var invalidConfigError = function invalidConfigError(e) {
  return new Error("Invalid config: can't read & parse the config file." + (e instanceof Error ? "Reason: " + e.message : ""));
};

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var validateConfig = function validateConfig(value) {
  if (process.env.NODE_ENV === "production") return;
  isset(value, "folder", "string");
  isset(value, "apiUrl", "string");
  validateUrl(value.apiUrl, "apiUrl");
  value.filesUrl && validateUrl(value.filesUrl, "filesUrl");
  value.revalidate && isset(value, "revalidate", "number");
  isset(value, "locales", "object");
  isset(value, "defaultLocale", "string");

  if (Object.entries(value.locales).flatMap(function (l) {
    return "content" in l[1] ? l[1].content : l[1];
  }).some(function (l) {
    return l.includes("/");
  })) {
    throw new ConfigError("Locales can't contain \"/\" character.");
  }

  if (!Object.keys(value.locales).includes(value.defaultLocale)) {
    throw new ConfigError("Default locale must be one of the specified locales.");
  }

  var invalidDomain;

  if (value.domains && (invalidDomain = Object.entries(value.domains).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        l = _ref2[1];

    return !Object.keys(value.locales).includes(l);
  }))) {
    throw new ConfigError("Domain ".concat(invalidDomain[0], " uses unknown locale."));
  }

  if (value.domains && Object.keys(value.domains).some(function (d) {
    return d.includes(":");
  })) {
    throw new ConfigError("Domains should not include ports.");
  }
};

var validateUrl = function validateUrl(u, name) {
  try {
    var _ = new URL(u);
  } catch (e) {
    throw new ConfigError("Invalid ".concat(name, " field, use absolute urls."));
  }
};

var isset = function isset(v, field, _typeof$1) {
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!required && !(field in v)) return;

  if (!(field in v)) {
    throw new ConfigError("Missing ".concat(field, " field."));
  }

  if (_typeof$1 && _typeof(v[field]) !== _typeof$1) {
    var article = _typeof$1.startsWith("o") || _typeof$1.startsWith("u") ? "an" : "a";
    throw new ConfigError("Field ".concat(field, " is not ").concat(article, " ").concat(_typeof$1, " (").concat(String(v[field]), ")."));
  }
};

var ConfigError = /*#__PURE__*/function (_Error) {
  _inherits(ConfigError, _Error);

  var _super = _createSuper$9(ConfigError);

  function ConfigError(message) {
    _classCallCheck(this, ConfigError);

    return _super.call(this, message && "Invalid config: ".concat(message));
  }

  return ConfigError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$p(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var prepareXcoreConfig = function prepareXcoreConfig(_ref) {
  var _process$env$XCORE_EN;

  var env = _ref.env,
      value = _objectWithoutProperties(_ref, ["env"]);

  if (process.env.XCORE_ENV && !(env !== null && env !== void 0 && env[process.env.XCORE_ENV])) {
    throw new Error("Invalid config: defined XCORE_ENV does not exist in config file");
  }

  var envValue = env === null || env === void 0 ? void 0 : env[process.env.XCORE_ENV];
  var result;

  if (envValue) {
    result = deepmerge(value, envValue);
  } else {
    result = value;
  }

  var normalizedLocales = Object.fromEntries(Object.entries(result.locales).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];

    return [k, Array.isArray(v) ? {
      content: v,
      routing: v[0]
    } : v];
  }));
  return _objectSpread$p(_objectSpread$p({}, result), {}, {
    currentEnv: (_process$env$XCORE_EN = process.env.XCORE_ENV) !== null && _process$env$XCORE_EN !== void 0 ? _process$env$XCORE_EN : null,
    locales: normalizedLocales
  });
};

var deepmerge = function deepmerge(a, b) {
  if (Array.isArray(a) || Array.isArray(b)) {
    return b !== null && b !== void 0 ? b : a;
  }

  if (a && _typeof(a) === "object" && b && _typeof(b) === "object") {
    var result = {};

    var keys = _toConsumableArray(new Set([].concat(_toConsumableArray(Object.keys(a)), _toConsumableArray(Object.keys(b)))));

    var _iterator = _createForOfIteratorHelper$2(keys),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        result[key] = deepmerge(a[key], b[key]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  }

  return b !== null && b !== void 0 ? b : a;
};

function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$q(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var XcoreConfig = /*#__PURE__*/function () {
  _createClass(XcoreConfig, [{
    key: "currentEnv",
    get: function get() {
      return this._value.currentEnv;
    }
  }, {
    key: "apiUrl",
    get: function get() {
      return this._value.apiUrl;
    }
  }, {
    key: "filesUrl",
    get: function get() {
      var _this$_value$filesUrl;

      return (_this$_value$filesUrl = this._value.filesUrl) !== null && _this$_value$filesUrl !== void 0 ? _this$_value$filesUrl : this._value.apiUrl;
    }
  }, {
    key: "publishedContentOnly",
    get: function get() {
      var _this$_value$publishe;

      return (_this$_value$publishe = this._value.publishedContentOnly) !== null && _this$_value$publishe !== void 0 ? _this$_value$publishe : true;
    }
  }, {
    key: "folder",
    get: function get() {
      return this._value.folder;
    }
  }, {
    key: "revalidate",
    get: function get() {
      return this._value.revalidate;
    }
  }, {
    key: "defaultLocale",
    get: function get() {
      return this.value.defaultLocale;
    }
  }, {
    key: "locales",
    get: function get() {
      return this._value.locales;
    }
  }, {
    key: "domains",
    get: function get() {
      return this._value.domains;
    }
  }, {
    key: "etc",
    get: function get() {
      return this._value.etc;
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    }
  }]);

  function XcoreConfig(value) {
    _classCallCheck(this, XcoreConfig);

    this._value = "currentEnv" in value ? value : prepareXcoreConfig(value);
  }

  _createClass(XcoreConfig, [{
    key: "getResolvedDomains",
    value: function getResolvedDomains() {
      var _this = this;

      var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (this.domains) {
        return this.domains;
      } else {
        return Object.fromEntries(Object.entries(this.locales).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              l = _ref2[0];

          return ["".concat(host, "/").concat(l === _this.defaultLocale ? "" : l), l];
        }));
      }
    }
    /** @deprecated use getCMS instead */

  }, {
    key: "getBaseCtx",
    value: function getBaseCtx(ctx) {
      return _objectSpread$q({
        apiUrl: this.apiUrl,
        filesUrl: this.filesUrl,
        published: this.publishedContentOnly
      }, ctx);
    }
  }, {
    key: "getCMS",
    value: function getCMS(ctxOrLocale, ctx) {
      if (typeof ctxOrLocale === "string") {
        return new XcoreCMS(this.getBaseCtx(_objectSpread$q(_objectSpread$q({}, ctx), {}, {
          locales: this.locales[ctxOrLocale]
        })));
      }

      return new XcoreCMS(this.getBaseCtx(ctxOrLocale));
    }
  }]);

  return XcoreConfig;
}();

var config;
var getXcoreConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!config) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", config);

          case 2:
            _context.t0 = XcoreConfig;
            _context.next = 5;
            return readXcoreConfig();

          case 5:
            _context.t1 = _context.sent;
            config = new _context.t0(_context.t1);
            validateConfig(config.value);
            return _context.abrupt("return", config);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getXcoreConfig() {
    return _ref.apply(this, arguments);
  };
}();
var getXcoreConfigSync = function getXcoreConfigSync() {
  if (config) return config;
  config = new XcoreConfig(readXcoreConfigSync());
  validateConfig(config.value);
  return config;
};
var getXcoreConfigFromEnv = function getXcoreConfigFromEnv() {
  if (config) return config;
  config = new XcoreConfig(readXcoreConfigFromEnv());
  validateConfig(config.value);
  return config;
};
var getXcoreConfigPathSync$1 = getXcoreConfigPathSync;
var getXcoreConfigPath$1 = getXcoreConfigPath;

export { AuthError, ChangePasswordError, LoginError, LoginErrorType, Method, RouteTypes, SaveCategoryError, SaveContentError, SaveGroupError, SaveUserError, TimeoutError, XcoreCMS, XcoreConfig, XcoreContent, XcoreError, XcoreFiles, XcoreRouting, XcoreTaxonomy, XcoreUsers, apiFetch, changePassword, collectIds, collectReverseIds, createCMS, defaultRequestHandler, deleteContent, errorRecord, fetchRichtextLinks, getApiRoot, getCategories, getCategory, getCategoryCompletion, getContent, getContentCompletion, getContentSlugs, getContentTypes, getContents, getGroup, getGroups, getPageContent, getQuery, getRelations, getRouteSlugList, getSearchResult, getUsers, getXcoreConfig, getXcoreConfigFromEnv, getXcoreConfigPath$1 as getXcoreConfigPath, getXcoreConfigPathSync$1 as getXcoreConfigPathSync, getXcoreConfigSync, handleAuthError, handleSaveCategoryError, handleSaveContentError, handleSaveError, handleSaveUserError, insertCategory, insertContent, insertUser, isSlugDuplicate, limit, loginRequest, logoutRequest, matchRoute, noopPromise, paginateQuery, paginateRes, pagination, parseRangeHeader, processContent, reorderCategory, resolveContent, resolveRelations, resolveReverseRelation, resolveReverseRelationsWithOptions, reverseRelation, saveCategory, saveContent, saveUser, updateCategory, updateContent, updateUser, uploadFiles, xcoreApiRequest, xcoreFetch };
//# sourceMappingURL=index.esm.js.map
